import { Pilot } from "../components/sections/Pilot";
import { StandaloneSection } from "./StandaloneSection";

export default function PilotPage() {
    return (
        <StandaloneSection>
            <Pilot />
        </StandaloneSection>
    );
}
